import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushStrengthIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M4 18a9 9 0 0 1 16 0" }),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 2.5,
			d: "M12 18 9 9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 18,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m5.5 15 1 .5M7 11l1 1m2-4 .5 1M14 8l-.5 1m3.5 2-1 1m2.5 3-1 .5",
			opacity: .35
		})
	]
});
export default SvgBrushStrengthIcon;
